import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    snackbar: false,
    snackbarText: 'snackbar text for 5 seconds.',
    snackbarTimeout: 5000,
    snackColor: 'primary',
    snackClose: true,
    snackIcon: '',
    snackIconColor: 'on-primary',
    loading: false,
  }),
  actions: {
    showSnackbar(data: snackevent) {
      if (data.error && data.error._reported && data.error._handledByComponent) {
        console.debug('Preventing duplicate snackbar for reported error');
        return;
      }

      if (!data.snackbarText) {
        console.warn('snackbar message did not contain req field: snackbarText')
      } else {
        let text = data.snackbarText;
        if (data.error && data.error.traceSuffix && !text.includes(data.error.traceSuffix)) {
          text += data.error.traceSuffix;
        }

        this.snackbar = data.snackbar ?? true;
        this.snackbarText = text;
        this.snackbarTimeout = data.snackbarTimeout ?? 5000;
        this.snackColor = data.snackColor ?? 'primary';
        this.snackClose = data.snackClose ?? true;
        this.snackIcon = data.snackIcon ?? '';
        this.snackIconColor = data.snackIconColor ?? 'on-primary';
      }
    },
    setLoading(value: boolean) {
      this.loading = value;
    },
    showGenericError(message: string, error?: snackevent['error']) {
      this.snackbar = true;
      let text = message;
      if (error && error.traceSuffix) text += error.traceSuffix;
      this.snackbarText = text;
      this.snackbarTimeout = 2000;
      this.snackColor = "warning";
    },
    showGenericSuccess(message: string) {
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarTimeout = 2000;
      this.snackColor = "success";
    }
  },
})
